<template>
  <Modal
      id="RegionEdit"
      width="60%"
      :open="visible"
      @cancel="visible = !visible"
      @ok="submit"
      :title="title"
      destroyOnClose
  >
    <Row align="middle" justify="center" class="modal">
      <Col span="18" >
        <Row>
          <Col span="24">
            <Form
                ref="regionForm"
                :model="form"
                layout="vertical"
                :rules="validateRules"
            >
              <Row justify="space-around">

                <Col span="10">
                  <FormItem :label="$t('region.table.name')" name="name">
                    <Input :placeholder="$t('region.validate.name')"
                           v-model:value="form.name">
                    </Input>
                  </FormItem>
                </Col>
                <Col span="10">
                  <FormItem :label="$t('region.table.address')" name="address">
                    <Input :placeholder="$t('region.validate.address')"
                           v-model:value="form.address">
                    </Input>
                  </FormItem>
                </Col>

                <Col span="10">
                  <FormItem :label="$t('region.table.lon')" name="lon">
                    <Input :placeholder="$t('region.validate.lon')"
                           v-model:value="form.lon">
                    </Input>
                  </FormItem>
                </Col>
                <Col span="10">
                  <FormItem :label="$t('region.table.lat')" name="lat">
                    <Input :placeholder="$t('region.validate.lat')"
                           v-model:value="form.lat">
                    </Input>
                  </FormItem>
                </Col>

<!--                <Col span="10">-->
<!--                  <FormItem :label="$t('region.table.ac_price_per_electricity') + '(kwh)'" name="acPricePerElectricity">-->
<!--                    <InputNumber-->
<!--                        v-model:value="form.acPricePerElectricity"-->
<!--                        :placeholder="$t('region.validate.ac_price_per_electricity')"-->
<!--                        :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"-->
<!--                        :parser="value => value.replace(/\$\s?|(,*)/g, '')"-->
<!--                        :min="0" :step="0.01"-->
<!--                        style="width:100%"-->
<!--                    />-->
<!--                  </FormItem>-->
<!--                </Col>-->
<!--                <Col span="10">-->
<!--                  <FormItem :label="$t('region.table.ac_price_per_minute') + '(min)'" name="acPricePerMinute">-->
<!--                    <InputNumber-->
<!--                        v-model:value="form.acPricePerMinute"-->
<!--                        :placeholder="$t('region.validate.ac_price_per_minute')"-->
<!--                        :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"-->
<!--                        :parser="value => value.replace(/\$\s?|(,*)/g, '')"-->
<!--                        :min="0" :step="0.01"-->
<!--                        style="width:100%"-->
<!--                    />-->
<!--                  </FormItem>-->
<!--                </Col>-->

<!--                <Col span="10">-->
<!--                  <FormItem :label="$t('region.table.dc_price_per_electricity') + '(kwh)'" name="dcPricePerElectricity">-->
<!--                    <InputNumber-->
<!--                        v-model:value="form.dcPricePerElectricity"-->
<!--                        :placeholder="$t('region.validate.dc_price_per_electricity')"-->
<!--                        :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"-->
<!--                        :parser="value => value.replace(/\$\s?|(,*)/g, '')"-->
<!--                        :min="0" :step="0.01"-->
<!--                        style="width:100%"-->
<!--                    />-->
<!--                  </FormItem>-->
<!--                </Col>-->
<!--                <Col span="10">-->
<!--                  <FormItem :label="$t('region.table.dc_price_per_minute') + '(min)'" name="dcPricePerMinute">-->
<!--                    <InputNumber-->
<!--                        v-model:value="form.dcPricePerMinute"-->
<!--                        :placeholder="$t('region.validate.dc_price_per_minute')"-->
<!--                        :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"-->
<!--                        :parser="value => value.replace(/\$\s?|(,*)/g, '')"-->
<!--                        :min="0" :step="0.01"-->
<!--                        style="width:100%"-->
<!--                    />-->
<!--                  </FormItem>-->
<!--                </Col>-->

<!--                <Col span="10">-->
<!--                  <FormItem name="byPowerUnit">-->
<!--                    <template #label>-->
<!--                      <div class="label-container">-->
<!--                        <span>{{$t('region.table.byPowerUnit') + '(kwh)'}}</span>-->
<!--                        <Tooltip placement="top" :title="$t('region.tooltip.byPowerUnit')" autoAdjustOverflow>-->
<!--                          <question-circle-outlined class="label-icon"/>-->
<!--                        </Tooltip>-->
<!--                      </div>-->
<!--                    </template>-->
<!--                    <InputNumber-->
<!--                        style="width: 100%"-->
<!--                        v-model:value="form.byPowerUnit"-->
<!--                        :placeholder="$t('region.validate.byPowerUnit')"-->
<!--                        :step="1"-->
<!--                    />-->
<!--                  </FormItem>-->
<!--                </Col>-->
<!--                <Col span="10">-->
<!--                  <FormItem name="byTimeUnit">-->
<!--                    <template #label>-->
<!--                      <div class="label-container">-->
<!--                        <span>{{$t('region.table.byTimeUnit') + '(min)'}}</span>-->
<!--                        <Tooltip placement="top" :title="$t('region.tooltip.byTimeUnit')" autoAdjustOverflow>-->
<!--                          <question-circle-outlined class="label-icon"/>-->
<!--                        </Tooltip>-->
<!--                      </div>-->
<!--                    </template>-->
<!--                    <InputNumber-->
<!--                        style="width: 100%"-->
<!--                        v-model:value="form.byTimeUnit"-->
<!--                        :placeholder="$t('region.validate.byTimeUnit')"-->
<!--                        :step="1"-->
<!--                    />-->
<!--                  </FormItem>-->
<!--                </Col>-->

<!--                <Col span="10">-->
<!--                  <FormItem name="maximumPower">-->
<!--                    <template #label>-->
<!--                      <div class="label-container">-->
<!--                        <span>{{$t('region.table.maximumPower') + '(kwh)'}}</span>-->
<!--                        <Tooltip placement="top" :title="$t('region.tooltip.maximumPower')" autoAdjustOverflow>-->
<!--                          <question-circle-outlined class="label-icon"/>-->
<!--                        </Tooltip>-->
<!--                      </div>-->
<!--                    </template>-->
<!--                    <InputNumber-->
<!--                        style="width: 100%"-->
<!--                        v-model:value="form.maximumPower"-->
<!--                        :placeholder="$t('region.validate.maximumPower')"-->
<!--                        :step="1"-->
<!--                    />-->
<!--                  </FormItem>-->
<!--                </Col>-->
<!--                <Col span="10">-->
<!--                  <FormItem name="maximumMinute">-->
<!--                    <template #label>-->
<!--                      <div class="label-container">-->
<!--                        <span>{{$t('region.table.maximumMinute') + '(min)'}}</span>-->
<!--                        <Tooltip placement="top" :title="$t('region.tooltip.maximumMinute')" autoAdjustOverflow>-->
<!--                          <question-circle-outlined class="label-icon"/>-->
<!--                        </Tooltip>-->
<!--                      </div>-->
<!--                    </template>-->
<!--                    <InputNumber-->
<!--                        style="width: 100%"-->
<!--                        v-model:value="form.maximumMinute"-->
<!--                        :placeholder="$t('region.validate.maximumMinute')"-->
<!--                        :step="1"-->
<!--                    />-->
<!--                  </FormItem>-->
<!--                </Col>-->

<!--                <Col span="10">-->
<!--                  <FormItem :label="$t('region.table.postpaid')" name="postpaid">-->
<!--                    <Select v-model:value="form.postpaid" :placeholder="$t('region.validate.postpaid')" :dropdownStyle="{zIndex: 9999999950}" @change="changePostpaid">-->
<!--                      <SelectOption :value="0">{{ $t('public.isTrue.0') }}</SelectOption>-->
<!--                      <SelectOption :value="1">{{ $t('public.isTrue.1') }}</SelectOption>-->
<!--                    </Select>-->
<!--                  </FormItem>-->
<!--                </Col>-->

<!--                <Col span="10">-->
<!--                  <FormItem :label="$t('region.table.directDebit')" name="directDebit">-->
<!--                    <Select v-model:value="form.directDebit" :placeholder="$t('region.validate.directDebit')" :dropdownStyle="{zIndex: 9999999950}" :disabled="form.postpaid !== 1">-->
<!--                      <SelectOption :value="0">{{ $t('public.isTrue.0') }}</SelectOption>-->
<!--                      <SelectOption :value="1">{{ $t('public.isTrue.1') }}</SelectOption>-->
<!--                    </Select>-->
<!--                  </FormItem>-->
<!--                </Col>-->

<!--                <Col span="10">-->
<!--                  <FormItem :label="$t('region.table.billingMethod')" name="billingMethod">-->
<!--                    <Select v-model:value="form.billingMethod" :placeholder="$t('region.validate.billingMethod')" :dropdownStyle="{zIndex: 9999999950}">-->
<!--                      <SelectOption :value="0">{{ $t('region.billingMethodType.0') }}</SelectOption>-->
<!--                      <SelectOption :value="1">{{ $t('region.billingMethodType.1') }}</SelectOption>-->
<!--                      <SelectOption :value="2">{{ $t('region.billingMethodType.2') }}</SelectOption>-->
<!--                    </Select>-->
<!--                  </FormItem>-->
<!--                </Col>-->

                <Col span="10">
                  <FormItem :label="$t('authority.table.sort')" name="sort">
                    <InputNumber
                        style="width: 100%"
                        v-model:value="form.sort"
                        :placeholder="$t('authority.validate.required.sort')"
                        :step="1"
                    />
                  </FormItem>
                </Col>

<!--                <Col span="10">-->
<!--                  <FormItem :label="$t('region.table.businessAllDay')" name="businessAllDay">-->
<!--                    <Select v-model:value="form.businessAllDay" @change="changeAllDay" :placeholder="$t('region.validate.businessAllDay')" :dropdownStyle="{zIndex: 9999999950}">-->
<!--                      <SelectOption :value="0">{{ $t('public.isTrue.0') }}</SelectOption>-->
<!--                      <SelectOption :value="1">{{ $t('public.isTrue.1') }}</SelectOption>-->
<!--                    </Select>-->
<!--                  </FormItem>-->
<!--                </Col>-->

<!--                <Col span="10">-->
<!--                  <FormItem  v-if="form.businessAllDay === 0" :label="$t('region.table.businessHours')" name="businessHours">-->
<!--                    <TimeRangePicker style="width: 100%" v-model:value="businessHours" format="HH:mm" valueFormat="HH:mm" @change="changeTime" />-->
<!--                  </FormItem>-->
<!--                </Col>-->

<!--                <Col span="10">-->
<!--                  <FormItem :label="$t('region.table.enableTimeoutFine')" name="enableTimeoutFine">-->
<!--                    <Select v-model:value="form.enableTimeoutFine" :placeholder="$t('region.validate.enableTimeoutFine')" :dropdownStyle="{zIndex: 9999999950}">-->
<!--                      <SelectOption :value="0">{{ $t('public.isTrue.0') }}</SelectOption>-->
<!--                      <SelectOption :value="1">{{ $t('public.isTrue.1') }}</SelectOption>-->
<!--                    </Select>-->
<!--                  </FormItem>-->
<!--                </Col>-->

<!--                <Col span="10">-->
<!--                  <FormItem v-if="form.enableTimeoutFine === 1" :label="$t('region.table.timeoutFine')" name="timeoutFine">-->
<!--                    <InputNumber-->
<!--                        style="width: 100%"-->
<!--                        v-model:value="form.timeoutFine"-->
<!--                        :placeholder="$t('region.validate.timeoutFine')"-->
<!--                        :step="1"-->
<!--                    />-->
<!--                  </FormItem>-->
<!--                </Col>-->

<!--                <Col span="10">-->
<!--                  <FormItem v-if="form.enableTimeoutFine === 1" :label="$t('region.table.timeoutCharging')" name="timeoutCharging">-->
<!--                    <InputNumber-->
<!--                        style="width: 100%"-->
<!--                        v-model:value="form.timeoutCharging"-->
<!--                        :placeholder="$t('region.validate.timeoutCharging')"-->
<!--                        :step="1"-->
<!--                    />-->
<!--                  </FormItem>-->
<!--                </Col>-->
                <Col span="10"></Col>

                <Col span="22">
                  <FormItem :label="$t('region.table.images')">
                    <UploadFile
                        :urlList="fileList === undefined || fileList === null ? [] : fileList"
                        :limit="3"
                        accept="image/*"
                        ref="upload_url"
                        @update_list="updateFileList"
                        @on_preview="onPreview"
                    />
                  </FormItem>
                </Col>
                <!--判断是否有子表，如果有则直接加入子表管理逻辑-->
              </Row>
            </Form>
          </Col>
        </Row>
      </Col>
      <!--      <ImageShow :url={imgUrl}></ImageShow>-->
      <Image
          v-if="imgIsShow"
          :style="{ display: 'none' }"
          :preview="{
            visible: imgIsShow,
            onVisibleChange: setVisible,
          }"
          :width="200"
          :height="200"
          :src="imgUrl"
          fallback="data:image/png;base64,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"
      ></Image>
    </Row>
  </Modal>
</template>

<script>
export default {
  name: "RegionEdit"
}
</script>

<script setup>
import {
  Modal,
  Row,
  Col,
  Form,
  FormItem,
  Input,
  InputNumber,
  Image,
  message,
  Select,
  SelectOption,
  Tooltip,
  TimeRangePicker
} from "ant-design-vue";
import {
  QuestionCircleOutlined
    
} from "@ant-design/icons-vue";
import {RegionAdd, RegionEdit} from "@/api/region"
import UploadFile from "@/components/Common/UploadFile"
import {useStore} from "vuex";
import {reactive, ref, toRefs} from "vue";
import {useI18n} from "vue-i18n"

const i18n = useI18n()
const emits = defineEmits(['updateList'])

const regionForm = ref()

// 是否管理员
const isAdmin = ref(useStore().getters.getIsAdmin)
let visible = ref(false)
let title = ref("")
let actionType = ref("")
let imgUrl = ref(undefined)
let imgIsShow = ref(false)
let businessHours = ref()

const data = reactive({
  form: {},
  fileList: [],
  selectList: {},
})
const {form,fileList} = toRefs(data)

const validateRules = reactive({
  idReg: [
    {
      required: true,
      message: i18n.t("region.validate.id_reg"),
      trigger: "change",
      type: "number",
    },
  ],
  name: [
    {
      required: true,
      message: i18n.t("region.validate.name"),
      trigger: "change",
    },
  ],
  acPricePerElectricity: [
    {
      required: true,
      message: i18n.t("region.validate.ac_price_per_electricity"),
      trigger: "change",
      type: "number",
    },
  ],
  acPricePerMinute: [
    {
      required: true,
      message: i18n.t("region.validate.ac_price_per_minute"),
      trigger: "change",
      type: "number",
    },
  ],
  lon: [
    {
      required: true,
      message: i18n.t("region.validate.lon"),
      trigger: "change",
    },
  ],
  lat: [
    {
      required: true,
      message: i18n.t("region.validate.lat"),
      trigger: "change",
    },
  ],
  address: [
    {
      required: true,
      message: i18n.t("region.validate.address"),
      trigger: "change",
    },
  ],
  dcPricePerElectricity: [
    {
      required: true,
      message: i18n.t("region.validate.dc_price_per_electricity"),
      trigger: "change",
      type: "number",
    },
  ],
  dcPricePerMinute: [
    {
      required: true,
      message: i18n.t("region.validate.dc_price_per_minute"),
      trigger: "change",
      type: "number",
    },
  ],
  tenantKey: [
    {
      required: false,
      message: i18n.t("region.validate.tenant_key"),
      trigger: "change",
    },
  ],
  byPowerUnit: [
    {
      required: true,
      message: i18n.t("region.validate.byPowerUnit"),
      trigger: "change",
    },
  ],
  byTimeUnit: [
    {
      required: true,
      message: i18n.t("region.validate.byTimeUnit"),
      trigger: "change",
    },
  ],
  postpaid: [
    {
      required: true,
      message: i18n.t("region.validate.postpaid"),
      trigger: "change",
    },
  ],
  businessAllDay: [
    {
      required: true,
      message: i18n.t("region.validate.businessAllDay"),
      trigger: "change",
    },
  ],
  businessHours: [
    {
      required: true,
      message: i18n.t("region.validate.businessHours"),
      trigger: "change",
    },
  ],
  billingMethod: [
    {
      required: true,
      message: i18n.t("region.validate.billingMethod"),
      trigger: "change",
    },
  ],
  timeoutFine: [
    {
      required: true,
      message: i18n.t("region.validate.timeoutFine"),
      trigger: "change",
    },
  ],
  timeoutCharging: [
    {
      required: true,
      message: i18n.t("region.validate.timeoutCharging"),
      trigger: "change",
    },
  ],
})

function addShow() {
  title.value = i18n.t("public.name.add");
  actionType.value = "add";
  _resetData();
  visible.value = true;
}

async function editShow(obj) {
  title.value = i18n.t("public.name.edit");
  actionType.value = "edit";
  _resetData();
  form.value = obj;
  if (obj.businessHours) {
    let tLs = obj.businessHours.split(',')
    businessHours.value.push(tLs[0].split('-')[0])
    businessHours.value.push(tLs[0].split('-')[1])
  }
  fileList.value = obj.imgList
  visible.value = true;
}


function submit() {
  regionForm.value.validate().then(() => {
    let api;
    switch (actionType.value) {
      case "add":
        api = new RegionAdd();
        break;
      case "edit":
        api = new RegionEdit();
        break;
      default:
        return false;
    }
    if (fileList.value) {
      form.value.imagesListStr = JSON.stringify(fileList.value)
    }
    delete form.value.createTime
    delete form.value.updateTime
    api.post(form.value).then((response, any) => {
      if (0 === parseInt(response.data.code)) {
        message.success(i18n.t("succeedMsg.0"));
        emits("updateList", response.data.data);
        visible.value = false;
      } else {
        if(response.data.code !== undefined){message.error(i18n.t("errorMsg." + response.data.code));}
      }
    });
  }).catch(() => {});
}

function updateFileList(f) {
  fileList.value = f
}

function changeAllDay(e) {

}

function changeTime(e) {
  form.value.businessHours = e[0] + "-" + e[1]
}

// 自定义文件预览
function onPreview(file) {
  imgUrl.value = file.url
  imgIsShow.value = true
}
function setVisible(value) {
  imgIsShow.value = value
}

function _resetData() {
  businessHours.value = []
  form.value = {};
}

function changePostpaid(e) {
  if (e === 0) {
    form.value.directDebit = 0
  }
}

defineExpose({
  addShow,
  editShow
});
</script>

<style lang="less">
 .modal {
   height: 65vh;
 }
 .label-container {
   display: flex;
   align-items: center;
 }

 .label-icon {
   margin-left: 4px;
   color: #999;
 }
</style>
